import { locationSlugsAtom } from "@/modules/api/locations.store.ts";
import { mergeQueries, type QMergedResult, type QResult } from "@/utils/query/mergeQueries.ts";
import { objectFromKeys } from "@warrenio/utils/collections/objs";
import { atom, type Atom } from "jotai/vanilla";

/** Create an atom that queries all locations and merges the results using {@link mergeDataFn}. */
export function atomAllLocationsQuery<T, TMerged>(
    locationQueryAtomFn: (location: string) => Atom<QResult<T>>,
    mergeDataFn: (data: T[]) => TMerged,
    locationsAtom: Atom<string[]> = locationSlugsAtom,
): Atom<QMergedResult<TMerged>> {
    return atom((get) => {
        const results = objectFromKeys(get(locationsAtom), (location) => get(locationQueryAtomFn(location)));
        return mergeQueries(results, mergeDataFn);
    });
}
